import React from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import { IScraperJobConfigurationFragment } from 'apps/spot-quote-control-panel/graphql/ScraperJobConfigurationFragment'
import { DemoModeAutocomplete, IDemoModeAutocompleteProps } from './DemoModeAutocomplete'

type IBaseControllerProps = ControllerProps<React.ComponentType<IDemoModeAutocompleteProps>>

export interface IControlledDemoModeAutocompleteProps
  extends Pick<IBaseControllerProps, 'control' | 'name' | 'defaultValue'> {
  jobConfig: IScraperJobConfigurationFragment
  setFocusedJob: React.Dispatch<React.SetStateAction<IScraperJobConfigurationFragment | undefined>>
}

export const ControlledDemoModeAutocomplete = ({
  control,
  defaultValue,
  jobConfig,
  name,
  setFocusedJob,
}: IControlledDemoModeAutocompleteProps) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ onChange, value }) => {
        const changeHandler: IDemoModeAutocompleteProps['onChange'] = newVal => {
          if (newVal && !Array.isArray(newVal) && typeof newVal === 'object' && newVal.id) {
            if (newVal.id === 'demo') {
              setFocusedJob({ ...jobConfig, demoMode: true })
              onChange(true)
            }
            if (newVal.id === 'live') {
              setFocusedJob({ ...jobConfig, demoMode: false })
              onChange(false)
            }
          } else {
            const modeUpdate = !jobConfig.demoMode
            setFocusedJob({ ...jobConfig, demoMode: modeUpdate })
            onChange(modeUpdate)
          }
        }

        return (
          <DemoModeAutocomplete onChange={changeHandler} value={value === true ? 'demo' : 'live'} />
        )
      }}
    />
  )
}
